import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { MaterialModule } from '../material/material.module';
import { AdvertisingComponent } from "./components/advertising/advertising.component";
import { CommonModule } from '@angular/common';
import { environment } from '../environments/environment';

@Component({
  selector: 'app-root',
  imports: [
    RouterOutlet,
    MaterialModule,
    AdvertisingComponent,
    CommonModule,
],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent {
  title = 'ucts-file-share-download';
  constructor() {
  }
}
